import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  Filter,
  TextInput,
  CreateButton
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";
import SupervisorAccount from "material-ui/svg-icons/action/supervisor-account";
import ChartIcon from "material-ui/svg-icons/editor/insert-chart";
import { Pagination, IconTitle, LinkButton } from "../components";
import { AgencyCreate as create, AgencyEdit as edit } from "./Detail";

import "./index.css";

const AgencyActions = ({ resource, basePath, refresh }) => (
  <CardActions className="agency-actions">
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);

const AgencyFilter = ({ ...props }) => (
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn
    />
  </Filter>
);

export const AgencyCreate = create;
export const AgencyEdit = edit;

export { default as UsersList } from "./UsersList";
export { default as DetailMarketer } from "./DetailMarketer";
export { default as ImportMarketer } from "./ImportMarketer";
export { default as EditDetailMarketer } from "./EditDetailMarketer";

export const AgencyList = props => (
  <List
    {...props}
    actions={<AgencyActions />}
    filters={<AgencyFilter />}
    title={<IconTitle icon="agency" title={"resources.agency.title"} />}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField label="resources.agency.field.name" source="name" />
      <TextField label="resources.agency.field.total" source="total_kol" />
      <DateField label="resources.agency.field.create_at" source="created_at" />
      <LinkButton
        {...props}
        icon={<SupervisorAccount />}
        style={{ textAlign: "right", width: 50 }}
        urlPath={"/users"}
      />
      <LinkButton
        {...props}
        icon={<ChartIcon />}
        style={{ textAlign: "right", width: 50 }}
        urlPath={"/commissions"}
      />
      <EditButton label="" style={{ textAlign: "right", width: 50 }} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/agency/index.js